<template>
 <div class="bg-white p-4 rounded-lg shadow">
  <apexchart type="line" :options="chartOptions" :series="series" />
 </div>
</template>

<script>
export default {
 name: "LineChart",
 props: {
  series: {
   type: Array,
   required: true,
  },
  categories: {
   type: Array,
   required: true,
  },
  title: {
   type: String,
   // Updated default title to reflect user focus
   default: "User Performance Percentages Over Time",
  },
  yAxisTitle: {
   type: String,
   default: "Percentage (%)",
  },
 },
 computed: {
  chartOptions() {
   return {
    chart: {
     height: "100%",
     type: "line",
     zoom: { enabled: false },
     toolbar: { show: false },
    },
    dataLabels: { enabled: false },
    stroke: {
     curve: "smooth",
     width: 3,
    },
    colors: ["#3b82f6", "#10b981"],
    title: {
     text: this.title,
     align: "left",
     style: {
      fontSize: "16px",
      color: "#333",
     },
    },
    subtitle: {
     text: this.$t("connectionAvailabilityPercentages"),
    },
    grid: {
     row: {
      colors: ["#f3f3f3", "transparent"],
      opacity: 0.5,
     },
    },
    xaxis: {
     categories: this.categories,
     //  title: { text: "Time Period" },
     labels: {
      style: { colors: "#6b7280" },
     },
    },
    yaxis: {
     title: { text: this.yAxisTitle },
     min: 0,
     max: 100, // Keep max at 100 for percentages
     labels: {
      show: true,
      style: { colors: "#6b7280" },
      formatter: function (val) {
       return val.toFixed(0);
      },
     },
    },
    grid: {
     borderColor: "#e5e7eb",
     strokeDashArray: 4,
    },
    legend: {
     position: "top",
     horizontalAlign: "right",
    },
    tooltip: {
     y: {
      // Updated tooltip for percentage
      formatter: function (val) {
       return val.toFixed(2) + " %";
      },
     },
    },
   };
  },
 },
};
</script>
